import React, { useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";
import { ModalBox, ModalDelete } from "../Outer/Modal";
import {
  SportAll,
  SportAllMap,
  SportAllSearch,
  SportDelete,
  SportsReg,
  SportsUpdate,
  UploadImage,
} from "../../redux/auth-reducer/auth-service";
import DataTable from "react-data-table-component";
import { Footer } from "../../Footer";
import { ToastContainer, toast } from "react-toastify";
import { ImageUrl } from "../../utils/config/config";
import { Loader } from "rsuite";
export const Sports = () => {
  const [data, setData] = useState();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageName, setImageName] = useState("");
  const [itemList, setItemList] = useState("");
  const [dataImage, setDataImage] = useState();
  const [dataImageUpdate, setDataImageUpdate] = useState();
  const [count, setCount] = useState(0);
  const [deleteRow, setDeleteRow] = useState(0);
  const [pageSize, setPageSize] = useState();
  const [imageResponse, setImageResponse] = useState();
  const [searchText, setSearchText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageAdd, setSelectedImageAdd] = useState(null);
  const [isBracket, setIsBracket] = useState(false);
  const [bracket, setBracket] = useState();
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [err, setErr] = useState(false);
  const pageOptions = [10, 20, 30, 50];
  const [editData, setEditData] = useState({
    sportImage: "",
    sportName: "",
    sportId: 0,
  });
  const [sportReg, setSportReg] = useState({
    sportName: "",
    sportImage: null,
    sportId: "",
  });

  function sidebarfun() {
    setData(!data);
  }
  const AddSport = () => {
    setShow(true);
  };
  const handleClosed = (e) => {
    setShowModal(false);
    setSelectedImage("");
    setSelectedImageAdd("");
    setShow(false);
    setShowModalEdit(false);
  };

  const handelSport = (e) => {
    setSportReg({ ...sportReg, [e.target.name]: e.target.value });

    if (e.target.value.length === 50) {
      setErr(true);
    } else {
      setErr("");
    }
  };

  useEffect(() => {
    setBracket(editData.isBracket);
  }, [editData]);

  const handleFileChange = (event) => {
    setLoading(true);
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (event) {
        setSelectedImageAdd(event.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    const dataList = event.target.files[0];
    const imageAPI = async () => {
      const formDataImage = new FormData();
      formDataImage.append("file", dataList);

      await UploadImage(formDataImage).then((res) => {
        setImageResponse(res);

        if (res?.data?.status == true) {
          setDataImage(res?.data?.message);
          setLoading(false);
        } else {
          toast.error(res?.message);
        }
      });
    };

    imageAPI();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setValidated(true);
    if (imageResponse?.status == false) {
      toast.error("Please upload image file minimume 2mb size.");
      return null;
    }
    const registerData = [
      {
        crudOperationId: true,
        sportsID: 0,
        sportName: sportReg.sportName,
        sportImage: dataImage || null,
        // "userId": 2,
        isBracket: isBracket,
      },
    ];

    await SportsReg(registerData).then((res) => {
      if (res?.data?.status == true) {
        setSelectedImageAdd("");
        setCount(count + 1);
        setShow(false);
        toast.success(res?.data?.message);
        setValidated(false);
        setDataImage("");
        setSportReg({
          sportsName: "",
          sportImage: null,
          sportsId: "",
          userId: 0,
        });
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  // Function to fetch data from API
  const SportAllFn = async (data) => {
    try {
      const response = await SportAll(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    SportAllFn(data); // Fetch data when currentPage changes
  }, [currentPage, count]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    SportAllFn(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const columns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,

      width: "80px",
    },

    {
      name: <strong>Logo</strong>,
      selector: (row) => (
        <>
          {row.sportImage == null || row.sportImage == "" ? (
            <img
              src="../image/sport-icon.png"
              width={50}
              className="img-fluid pt-3 pb-3"
            />
          ) : (
            <img
              src={ImageUrl + row?.sportImage}
              width={50}
              className="img-fluid pt-3 pb-3"
            ></img>
          )}
        </>
      ),

      sortable: true,
    },
    {
      name: <strong>Sport Name</strong>,
      selector: (row) => row?.sportName,
      sortable: true,
    },

    {
      name: <strong>Action</strong>,
      selector: (row) => (
        <>
          <button
            type="button"
            className="text-danger btn-aucion  ms-1"
            onClick={() => deleteFn(row?.sportId)}
          >
            <icons.Trash />
          </button>
          <button
            type="button"
            className="text-success btn-aucion ms-1"
            onClick={() => edit(row)}
          >
            <icons.PencilSquare />
          </button>
        </>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  const handelEditSport = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
    if (e.target.value.length === 50) {
      setErr(true);
    } else {
      setErr("");
    }
  };
  const handelBracket = (event) => {
    setIsBracket(event.target.checked);
  };

  const edit = async (edititem) => {
    setShowModalEdit(true);

    setSelectedImageAdd(edititem?.sportImage);
    setEditData(edititem);
    setDataImageUpdate(edititem?.sportImage);
    if (!edititem?.sportImage) {
      setSelectedImage("../image/sport-icon.png"); // Replace with your default image path
    }
  };

  const deleteFn = async (sportId) => {
    setDeleteRow(sportId);
    setShowModal(!showModal);
  };

  const update = async () => {
    const registerData = imageName
      ? {
          crudOperationId: false,
          sportId: editData?.sportId,
          sportName: editData?.sportName,
          sportImage: dataImageUpdate || null,

          isBracket: isBracket,
        }
      : {
          crudOperationId: false,
          sportId: editData?.sportId,
          sportName: editData?.sportName,
          sportImage: dataImageUpdate || null,

          isBracket: isBracket,
        };

    await SportsUpdate(registerData).then((res) => {
      if (res?.status == true) {
        setCount(count + 1);
        setShowModalEdit(false);
        setSelectedImage("");
        toast.success(res?.message);
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handelDelete = async () => {
    await SportDelete(deleteRow).then((res) => {
      if (res?.status == true) {
        setShowModal(!showModal);
        setCount(count + 1);
        toast.success("Delete Sport Successfully");
      } else {
        toast.error(res?.message);
        setShowModal(!showModal);
      }
    });
  };

  const SportAllFnSearch = async (data) => {
    try {
      const response = await SportAllSearch(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value === " ") {
      return; // Ignore the input if it's just a space
    }
    setSearchText(value);
    const data = {
      SearchTerm: value,
      SortOrder: false,
      SortColumn: "sportName",
    };
    SportAllFnSearch(data);
  };

  const filteredData = searchText
    ? itemList.filter((item) => {
        return item.sportName.toLowerCase().includes(searchText.toLowerCase());
      })
    : itemList;

  const handelImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        setSelectedImage(e.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
    setSelectedFile(e.target.files[0].name);
    setImageName(e.target.files[0].name);
    const dataList = e.target.files[0];
    const imageAPI = async () => {
      const formDataImage = new FormData();
      formDataImage.append("file", dataList);
      await UploadImage(formDataImage).then((res) => {
        if (res?.data?.status == true) {
          setDataImageUpdate(res?.data?.message);
        } else {
        }
      });
    };

    imageAPI();
  };
  const clearSearch = () => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    SportAllFn(data);
    setSearchText("");
  };

  return (
    <>
      <ModalBox
        show={showModalEdit}
        onHide={handleClosed}
        title="Update Sports"
        body={
          <>
            <input type="hidden" className="form-control"></input>
            <br />
            <input
              type="text"
              className="form-control"
              maxLength={50}
              name="sportName"
              onChange={handelEditSport}
              value={editData?.sportName}
              required
            ></input>
            <br />
            {err ? (
              <p style={{ color: "#dc3545" }}>
                Sport shouldn't exceed 50 characters
              </p>
            ) : (
              ""
            )}
            <input
              type="file"
              className="form-control"
              name="sportImage"
              onChange={handelImage}
            ></input>
            <br />

            {selectedImage ? (
              <img src={selectedImage} alt="Selected" width={100} />
            ) : (
              <img src={ImageUrl + editData?.sportImage} width={100}></img>
            )}

            <Form.Group>
              <label className="d-flex  mt-3">
                {editData.isBracket === true ? (
                  <>
                    <input
                      type="checkbox"
                      className="inputCheck"
                      onClick={handelBracket}
                      name="isBracket"
                      checked={bracket}
                      disabled={true}
                    />
                    <p>There is Bracket in this Sport.</p>
                  </>
                ) : (
                  "There is no Bracket in this Sport."
                )}
                {/* Do you want to add tournament bracket. */}
              </label>
            </Form.Group>
          </>
        }
        footer={
          <>
            <Button
              variant="primary"
              className="btn-Save me-3"
              onClick={update}
            >
              Update
            </Button>
            <Button
              type="button"
              className="btn-Cancel secondary"
              onClick={handleClosed}
            >
              Cancel
            </Button>
          </>
        }
      />

      <ModalDelete
        show={showModal}
        onHide={handleClosed}
        title="Delete Sports"
        body={
          <>
            <p>Are you want to delete the sport?</p>
          </>
        }
        footer={
          <>
            <Button variant="danger" onClick={handelDelete}>
              Delete
            </Button>
            <Button variant="secondary" onClick={handleClosed}>
              Close
            </Button>
          </>
        }
      />

      <ModalBox
        show={show}
        onHide={handleClosed}
        title="Add Sport"
        body={
          <>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                  <Form.Label>Sport Name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="sportName"
                    maxLength={50}
                    onChange={handelSport}
                    placeholder="Sport Name"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter valid sport name.
                  </Form.Control.Feedback>
                  {err ? (
                    <p style={{ color: "#dc3545" }}>
                      Sport shouldn't exceed 50 characters
                    </p>
                  ) : (
                    ""
                  )}
                </Form.Group>

                <Form.Group as={Col} md="6" controlId="validationCustom02">
                  <Form.Label>Logo</Form.Label>
                  <Form.Control
                    type="file"
                    name="sportImage"
                    onChange={handleFileChange}
                    placeholder="Choose file"
                  />

                  {loading && <Loader />}

                  {dataImage ? (
                    <img
                      src={ImageUrl + dataImage}
                      alt="Selected"
                      width={100}
                    />
                  ) : (
                    ""
                  )}

                  <p className="mt-2 image-upload-mess">
                    (jpeg, jpg, png and size upto 2 mb)
                    <span className="text-danger">*</span>
                  </p>
                </Form.Group>
                <Form.Group>
                  <label className="d-flex  mt-3">
                    <input
                      type="checkbox"
                      className="inputCheck"
                      onClick={handelBracket}
                      name="isBracket"
                      value={isBracket}
                    />
                    Do you want to add contest bracket.
                  </label>
                </Form.Group>
              </Row>
              <Row>
                <Col md={6}></Col>
                <Col md={6} className="text-right">
                  {" "}
                  <Button type="submit" className="btn-Save me-3">
                    Save
                  </Button>
                  <Button
                    type="button"
                    className="btn-Cancel secondary"
                    onClick={handleClosed}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </>
        }
      />

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Sports</h1>
            </Col>
            <Col md={6} className="text-right">
              <Button
                className="primary button-create-auction btn btn-primary "
                onClick={AddSport}
              >
                <icons.Plus class="icon-plus" /> Add Sport
              </Button>
            </Col>
          </Row>

          <div className="group_data_table sport">
            {/* <div className='search-input d-flex align-items-center'>
                            <input type="text" className='form-control mb-3 mt-3' placeholder="Search..." value={searchText} onChange={handleSearch} />
                        </div> */}
            <div className="search-input d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>
            <div>
              <DataTable
                title="Sport List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      {totalRows > 1 ? (
                        <>
                          <label>Rows per page: </label>{" "}
                          <select
                            id="itemsPerPage"
                            value={perPage}
                            onChange={handlePerPageChange}
                          >
                            {pageOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </>
                      ) : (
                        ""
                      )}

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {" "}
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
